<template>
  <section id="signin" class="w-100 h-100">
    <Background/>
    
    <Header/>
    
    <v-row no-gutters class="mt-16 pt-16">
      <v-col></v-col>
      <v-col cols="10" sm="6" md="4" xl="3">
        <v-img
          :src="logo"
          max-width="70%"
          position="center center"
          class="mx-auto mb-8"
        ></v-img>

        <v-card elevation="5">
          <v-card-title class="text-h5 font-weight-normal">Login</v-card-title>
          <v-card-text>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              @submit.prevent
            >
              <v-text-field
                v-model="user.displayName"
                :rules="rules.displayName"
                label="Nome de exibição"
                @keyup.enter="signin"
                required
                class="mt-0 pt-0"
              />
             
              <v-text-field
                v-model="user.email"
                :rules="rules.email"
                label="E-mail"
                @keyup.enter="signin"
                required
                class="mt-0 pt-0"
              />

              <v-text-field
                v-model="user.password"
                :rules="rules.password"
                label="Senha"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                @keyup.enter="signin"
                required
                class="mt-0 pt-0"
              />
              
              <v-text-field
                v-model="user.confirmPassword"
                :rules="rules.confirmPassword"
                label="Confime a senha"
                :type="showPassword ? 'text' : 'password'"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                @keyup.enter="signin"
                required
                class="mt-0 pt-0"
              />
              
              <v-row no-gutters align-center class="mt-2">
                <v-col cols="12" lg="8">
                  <v-alert
                    :value="res.value"
                    :type="res.type"
                    :icon="res.icon"
                    text
                    dense
                    dismissible
                    transition="scale-transition"
                    class="ma-0 mr-lg-1 wp-preline"
                  >{{res.content}}</v-alert>
                </v-col>
                <v-col cols="12" lg="4">
                  <v-btn
                    :disabled="!valid"
                    color="success"
                    @click="signin"
                    class="d-block mt-2 mb-1 ml-auto mt-lg-0"
                  >
                    Cadastrar
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col></v-col>
    </v-row>
  </section>
</template>

<script>
import Header from '@/components/Auth/Header.vue'
import Background from '@/components/Auth/Background.vue'
import { createNamespacedHelpers, mapMutations } from 'vuex'
const { mapActions:authActions } = createNamespacedHelpers('auth')
export default {
  name: 'SignIn',
  components: {Header, Background},
  data: () => ({
    logging: false,
    valid: true,
    res: {
      value: false,
      type: 'info',
      icon: null,
      content: ''
    },
    user: {
      active: true,
      type: 'user'
    },
    rules: {
      name: [
        v => !!v || 'Informe o nome',
      ],
      displayName: [
        v => !!v || 'Informe o nome de exibição',
      ],
      login: [
        v => !!v || 'Informe o login',
      ],
      email: [
        v => !!v || 'Informe o e-mail',
        v => /.+@.+\..+/.test(v) || 'Informe um e-mail válido',
      ],
      password: [
        v => !!v || 'Informe a senha',
        v => (v) ? v.length > 5 || 'A senha deve conter pelo menos 6 caracteres' : true,
      ],
      confirmPassword: [
        v => !!v || 'Informe a senha de confirmação',
      ],
    },
    showPassword: false
  }),
  methods: {
    ...mapMutations(['setLoading']),
    ...authActions(['signUp', 'signIn']),
    
    signin() {
      if(this.$refs.form.validate()) {
        if (this.user.password !== this.user.confirmPassword) { 
          this.res = {
            value: true,
            type: 'error',
            icon: 'mdi-alert-outline',
            content: 'As senhas informadas diferem!'
          }
          this.setLoading({stats: false})
          return
        }

        this.setLoading({stats: true, message: 'cadastrando novo usuário'})
        this.signUp(this.user)
          .then(res => {
            if(!res.error) {
              this.res = {
                value: true,
                type: 'success',
                content: 'Cadastro efetuado!'
              }
              this.setLoading({stats: true, message: 'acessando'})
              this.$router.push('/')
            } else {
              this.res = {
                value: true,
                type: 'error',
                icon: 'mdi-alert-outline',
                content: res.error
              }
            }
            this.setLoading({stats: false})
          })
          .catch(err => {
            console.error(err)
            this.res = {
              value: true,
              type: 'error',
              icon: 'mdi-alert-outline',
              content: 'Erro interno, favor contactar o administrador.'
            }
            this.setLoading({stats: false})
          })
      }
    },
  },
  computed: {
    logo() {
      return this.$appConfig.logo ? this.$appConfig.logo :  '@/assets/logo.png'
    }
  },
  created() {
    this.setLoading({stats: false})
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (to.meta.requireClaim && (!vm.$appConfig.claims || !vm.$appConfig.claims[to.meta.requireClaim])) { next('/') }
      else { next() }
    })
  }
}
</script>

<style lang="scss">

</style>